import React from 'react'

import type { AlertFilterState } from 'features/alerts/features/create-alert/alert-filter-state'
import { useAlertFilterControl } from 'features/alerts/features/create-alert/components/alert-definition/use-alert-filter-control'
// bully ignore[no-cross-feature-private-imports: FilterControl is the same panel body every other v2-native filter UI in the app mounts (charts-v2's own sidebar, dashboards-v2-1's tile sidebar, trend-detection's agent-create form — see AgentFilterPanel.tsx's identical ignore) — the charts-v2 barrel only value-exports higher-level sidebar chrome that doesn't fit here, and only type-exports FilterControlProps. follow-up: .agents/follow-ups/bully-typescript-cross-feature-hooks.md]
import { FilterControl } from 'features/charts-v2/components/FilterControl'
import type { FilterOption } from 'features/filters/types'

interface Props {
  filterState: AlertFilterState
  setFilterState: (filterState: AlertFilterState) => void
  filterOptions: FilterOption[]
}

// Alerts has no smart-search affordance — legacy alerts only ever exposed
// keyword filtering (search_terms/search_criteria/search_terms_logical), not
// a free-text smart-search phrase, and this migration preserves that scope
// rather than adding it. `useAlertFilterControl` keeps `smartSearchValue`
// pinned to `null` (hidden) for exactly this reason.
const AlertDefinition: React.FC<Props> = ({
  filterState,
  setFilterState,
  filterOptions,
}) => {
  const filterControlProps = useAlertFilterControl(filterState, setFilterState)

  return (
    <FilterControl
      filterOptions={filterOptions}
      isFilterOptionsLoading={false}
      // The form's own "Filters" label already names this section, so the
      // control's "Filter" heading and [+] are dropped: the dashed
      // "+ Add filters" box is the one add entry point, below any applied
      // filters.
      hideFilterHeaderRow
      alwaysShowAddFilters
      addFiltersRowPosition="after"
      // The editor sits in a right-hand drawer, so there is no room to the
      // trigger's right for the popover: center it in the viewport instead.
      filterPopoverAnchorMode="center"
      {...filterControlProps}
    />
  )
}

export default AlertDefinition
